import {useNavigate, useParams, useLocation} from "react-router-dom";
import useData from "../../../hooks/useData";
import {useEffect, useState} from "react";
import {getBillingInfos, getCustomLineList} from "../../../api/admin/billingReq";
import useAuth from "../../../hooks/useAuth";
import Missing from "../../Missing";
import FormBillingDetail from "../../../forms/admin/billing/FormBillingDetail";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";

export default function ViewBillingInfos() {

    const { auth } = useAuth();
    const token = auth.token;
    const { id } = useParams();
    const location = useLocation();
    const fromSearch = location.state?.fromSearch;
    const { billingInfos, setBillingInfos } = useData();
    const navigate = useNavigate();
    const [ showModalDetail, setShowModalDetail ] = useState(false);
    const [ customLineList, setCustomLineList ] = useState();
    const [ totalCustomLines, setTotalCustomLines ] = useState(0);
    const [ totalHt, setTotalHt ] = useState(0);
    const [ totalDeceasedHt, setTotalDeceasedHt ] = useState(0);
    const [ totalTemplateHt, setTotalTemplateHt ] = useState(0);
    const [ totalTva, setTotalTva ] = useState(0);

    const apiBillingInfos = async () => {
        const response = await getBillingInfos(token, id);
        setBillingInfos(response);
    }

    const apiCustomLineList = async () => {
        const response = await getCustomLineList(token, id);
        setCustomLineList(response);
    }

    useEffect(() => {
        apiBillingInfos();
        apiCustomLineList();
    }, [ id ]);

    useEffect(() => {
        if (billingInfos) {
            setTotalDeceasedHt(billingInfos?.deceasedNumber * billingInfos.deceasedPrice);
            setTotalTemplateHt(billingInfos?.templateNumber * billingInfos.templatePrice);
        }
    }, [ billingInfos ]);

    useEffect(() => {
        if (totalTemplateHt && totalDeceasedHt && totalCustomLines) {
            setTotalHt(totalTemplateHt + totalDeceasedHt + totalCustomLines);
        }
    }, [ totalTemplateHt, totalDeceasedHt, totalCustomLines ]);

    useEffect(() => {
        if (billingInfos?.totalHtReduct) {
            setTotalTva(billingInfos?.totalHtReduct * billingInfos?.tvaRate / 100);
        }
    }, [ billingInfos ]);

    const handleModal = () => {
        setShowModalDetail(true)
    }

    useEffect(() => {
        if (customLineList?.length > 0) {
            for(let i = 0; i < customLineList?.length; i++) {
                setTotalCustomLines(customLineList[i].quantity * customLineList[i].unitPrice);
            }
        }
    }, [ customLineList ]);

    return (
        <main className="admin">
            { billingInfos?.error &&
                <Missing />
            }
            { !billingInfos?.error &&
                <>
                <Header
                    parent="Facturation"
                    location="Détail d'une facture"
                    slug="/admin/facturation"
                />
                <div>
                    { showModalDetail &&
                        <div className='modal billing-infos'>
                            <FormBillingDetail apiBillingInfos={apiBillingInfos} customLineList={customLineList} apiCustomLineList={apiCustomLineList} setShowModal={setShowModalDetail} legend="Détail d'une facture"/>
                        </div>
                    }
                    <Icon source="fa fa-file-invoice-dollar" span="Détail d'une facture"/>
                    <div className="double-fieldset">
                    <fieldset className="month-date">
                        <div className="billing-detail-column">
                            <div className="form-input">
                                <label>Agence</label>
                                <span>{billingInfos?.agencyName} ( {billingInfos?.zipcode} {billingInfos?.city} ) </span>
                            </div>
                            <div className="form-input">
                                <label>Référence contrat</label>
                                <span>{billingInfos?.contractReference}</span>
                            </div>
                            <div className="form-input">
                                <label>Mois de facturation</label>
                                <span>{billingInfos?.month}</span>
                            </div>
                            <div className="form-input">
                                <label>Numéro de facture</label>
                                <span>{billingInfos?.invoiceNumber}</span>
                            </div>
                            <div className="form-input">
                                <label>Date</label>
                                <span>{billingInfos?.date}</span>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset className="facturation-detail">
                        <div className="dashboard-facturation dashboard">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Produits</th>
                                        <th>Quantité</th>
                                        <th>Tarifs H.T.</th>
                                        <th>Total H.T.</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span>Solutions Multi Services - (Défunts)</span></td>
                                        <td><input type="text" disabled={true} value={billingInfos?.deceasedNumber}/></td>
                                        <td><input type="text" disabled={true} value={parseFloat(billingInfos?.deceasedPrice).toFixed(2)}/>€</td>
                                        <td><input type="text" disabled={true} value={parseFloat(totalDeceasedHt).toFixed(2)}/>€</td>
                                    </tr>
                                    {(billingInfos?.templateNumber > 0) &&
                                    <tr>
                                        <td><span>Site Internet</span></td>
                                        <td><input type="text" disabled={true} value={billingInfos?.templateNumber}/></td>
                                        <td><input type="text" disabled={true} value={parseFloat(billingInfos?.templatePrice).toFixed(2)}/>€</td>
                                        <td><input type="text" disabled={true} value={parseFloat(totalTemplateHt).toFixed(2)}/>€</td>
                                    </tr>}
                                    { customLineList?.map((line, index) => (
                                            <tr key={index}>
                                                <td><span>{line.name}</span></td>
                                                <td><input type="text" disabled={true} value={line?.quantity}/></td>
                                                <td><input type="text" disabled={true} value={parseFloat(line?.unitPrice).toFixed(2)}/>€</td>
                                                <td><input type="text" disabled={true} value={parseFloat(totalCustomLines).toFixed(2)}/>€</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td colSpan="2"></td>
                                    <td><span>Total H.T.</span></td>
                                    <td><span>{totalHt ? totalHt : 0} €</span></td>
                                    </tr>
                                    { billingInfos?.totalHtReduct > 0 &&
                                        <tr>
                                            <td colSpan="2"></td>
                                            <td><span>Total avec remises</span></td>
                                            <td><span>{parseFloat(billingInfos?.totalHtReduct).toFixed(2)} €</span></td>
                                        </tr>
                                    }
                                    <tr>
                                        <td colSpan="2"></td>
                                        <td><span>T.V.A. (20.00 %)</span></td>
                                        <td><span>{parseFloat(totalTva).toFixed(2)} €</span></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2"></td>
                                        <td><span>Total TTC</span></td>
                                        <td><span>{parseFloat(billingInfos?.totalHtReduct + totalTva).toFixed(2)} €</span></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className="buttons-container">
                            <button className="red-button" onClick={handleModal}><i className="fa fa-pen-to-square"></i><span>Modifier</span></button>
                        </div>
                    </fieldset>
                    </div>
                </div>
            </>
            }
            <button onClick={() => fromSearch ? navigate('/admin/facturation', { state: { openSearch: true } }) : navigate(-1)}>
                <i className="fa fa-arrow-left"/><span>Retour</span>
            </button>
        </main>
    )
}